export default function useTurnstile() {
  const config = useRuntimeConfig();

  const isDisabled = config.public.disableTurnstile;
  const token = ref<string>('');

  async function verify() {
    if (isDisabled) {
      console.warn('Verification skipped because turnstile is disabled in config');
      return true;
    }

    const result = await $fetch('/_turnstile/validate', {
      method: 'POST',
      body: { token: token.value }
    });
  
    return result && result.success;
  }

  return {
    isDisabled,
    token,
    verify
  }
}
